import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { get, includes } from 'lodash'
import { Box, Button, Grid, Typography, Checkbox, FormControlLabel, FormGroup } from '@material-ui/core'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/pro-light-svg-icons'
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons'

import api from 'common/api'
import { actions as userActions } from 'store/user'
import userPermissions from 'common/system-permissions'

const canMangageDocuments = (permissions) => includes(permissions, userPermissions.PERFORM_ADMISSIONS_TASKS)

export class AccountSettings extends React.Component {
  static propTypes = {
    canMangageDocuments: PropTypes.bool.isRequired,
    email: PropTypes.string.isRequired,
    fetchUser: PropTypes.func.isRequired,
    isEmailOptIn: PropTypes.bool,
  }
  componentDidMount() {
    document.title = 'Scoir - My Profile Account Settings'
  }
  updateEmailPreference = (isToggled) => {
    let promise
    if (isToggled) {
      promise = api.put('/api/user/emailoptin')
    } else {
      promise = api.delete('/api/user/emailoptin')
    }
    promise.then(() => this.props.fetchUser())
  }
  render() {
    const { canMangageDocuments, email, isEmailOptIn } = this.props
    return (
      <Grid
        container
        spacing={4}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <Box
            bgcolor="background.paper"
            height="100%"
            padding={2}
          >
            <Box
              display="flex"
              alignItems="center"
              borderBottom={1}
              borderColor="divider"
              minHeight="40px"
            >
              <Box
                color="grey.700"
                size="lg"
                mr={1}
              >
                <FontAwesomeIcon icon={faEnvelope} />
              </Box>
              <Typography>
                <strong>Account Email</strong>
              </Typography>
            </Box>
            <Box mt={{ xs: 0, md: 2 }}>
              <Typography>{email}</Typography>
              {canMangageDocuments && (
                <Box mt={1}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="account-settings-notifications-checkbox"
                          checked={isEmailOptIn || false}
                          onChange={(e) => this.updateEmailPreference(e.target.checked)}
                          color="primary"
                          disableRipple={false}
                        />
                      }
                      label={`Send me notifications about new documents available for download via email.`}
                    />
                  </FormGroup>
                </Box>
              )}
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Box
            bgcolor="background.paper"
            height="100%"
            padding={2}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              minHeight="40px"
            >
              <Box
                display="flex"
                alignItems="center"
              >
                <Box
                  color="grey.700"
                  size="lg"
                  mr={1}
                >
                  <FontAwesomeIcon icon={faLock} />
                </Box>
                <Typography>
                  <strong>Reset Password</strong>
                </Typography>
              </Box>
              <Button
                component={Link}
                color="primary"
                variant="outlined"
                to={`${import.meta.env.BASE_URL}/change-password`}
              >
                Reset
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    )
  }
}

export default connect(
  (store) => ({
    email: get(store.user.record, 'Email'),
    isEmailOptIn: get(store.user.record, 'NotificationPreference.EmailOptIn'),
    canMangageDocuments: canMangageDocuments(get(store.user.record, 'Permissions', [])),
  }),
  {
    fetchUser: userActions.fetchUser,
  },
)(AccountSettings)
